import { call, put, takeEvery } from "redux-saga/effects";
import { getListaLogo, getLogo, getLogoAll, getLogoHistory, getLogoHistoryList, saveLogo } from "./actions";
import moment from "moment";
import { emptyStringToNull } from "../../helpers/null_empty_string_helper";
import { LOGO_URL } from "../../helpers/url_api_helper";
import { LOGO } from "./actionTypes";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";

function* listarLogo({ payload }) {
  const filterLogo = payload;
  try {
    emptyStringToNull(filterLogo);
    const res = yield call(LOGO_URL.getLogos, filterLogo);
    yield put(getListaLogo.success(res));
  } catch (error) {
    yield put(getListaLogo.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* obterLogo({ payload }) {
  const { logoId } = payload;
  try {
    const res = yield call(LOGO_URL.getLogo, logoId);
    res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString();
    res.updateDate =
      res.updateDate !== null
        ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString()
        : "";
    yield put(getLogo.success(res));
  } catch (error) {
    yield put(getLogo.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* salvarLogo({ payload }) {
  const { body, type } = payload;
  try {
    if (type === "POST") {
      yield call(LOGO_URL.postLogo, body);
      yield put(saveLogo.success(true));
    } else {
      yield call(LOGO_URL.putLogo, body);
      yield put(saveLogo.success(true));
    }
  } catch (error) {
    yield put(saveLogo.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* listarLogoHistory({ payload }) {
  try {
    const { logoId, page } = payload;
    const res = yield call(LOGO_URL.getLogoHistoryList, logoId, page);
    yield put(getLogoHistoryList.success(res));
  } catch (error) {
    yield put(getLogoHistoryList.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* obterLogoHistory({ payload }) {
  const { logoHistoryId } = payload;
  try {
    const res = yield call(LOGO_URL.getLogoHistory, logoHistoryId);
    res.createDate = moment(res.createDate).format("DD MMM/YY hh:mm A").toString();
    res.updateDate =
      res.updateDate !== null
        ? moment(res.updateDate).format("DD MMM/YY hh:mm A").toString()
        : "";
    yield put(getLogoHistory.success(res));
  } catch (error) {
    yield put(getLogoHistory.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* listarLogoAll() {
  try {
    const res = yield call(LOGO_URL.getLogoAll);
    yield put(getLogoAll.success(res));
  } catch (error) {
    yield put(getLogoAll.fail(normalizeApiError(error, "Something went wrong retrieving the system's logo, please try again later")))
  }
}

function* LogoSaga() {
  yield takeEvery(LOGO.GET_LISTA_LOGO.REQUEST, listarLogo);
  yield takeEvery(LOGO.GET_LOGO.REQUEST, obterLogo);
  yield takeEvery(LOGO.SAVE_LOGO.REQUEST, salvarLogo);
  yield takeEvery(LOGO.GET_LOGO_HISTORY_LIST.REQUEST, listarLogoHistory);
  yield takeEvery(LOGO.GET_LOGO_HISTORY.REQUEST, obterLogoHistory);
  yield takeEvery(LOGO.GET_LOGO_ALL.REQUEST, listarLogoAll);
}

export default LogoSaga;
